import { apiService } from '@/services/APIService';

export default {
  getFreeUsers(id, groupId, params) {
    return apiService.get(`/places/event/${id}/free-users/groups/${groupId || ''}`, params);
  },

  getEventStageFreeUsers(id, groupId, params) {
    return apiService.get(`/places/event-stage/${id}/free-users/groups/${groupId || ''}`, params);
  },

  getEventStageFreeTeams(id, groupId, params) {
    return apiService.get(`/places/event-stage/${id}/free-teams/groups/${groupId || ''}`, params);
  },

  getFreeTeams(id, groupId, params) {
    return apiService.get(`/places/event/${id}/free-teams/groups/${groupId || ''}`, params);
  },

  getPublicEventPlaces(id, params) {
    return apiService.get(`/public/places/event/${id}`, params);
  },

  getEventPlaces(id, params) {
    return apiService.get(`/places/event/${id}`, params);
  },

  getStagesPlaces(id, params) {
    return apiService.get(`/places/event-stage/${id}`, params);
  },

  getPublicStagesPlaces(id, params) {
    return apiService.get(`/public/places/event-stage/${id}`, params);
  },

  awardStageUsers(id, groupId, params) {
    return apiService.post(`/places/event-stage/${id}/users/groups/${groupId || ''}`, params);
  },

  awardStageTeams(id, groupId, params) {
    return apiService.post(`/places/event-stage/${id}/teams/groups/${groupId || ''}`, params);
  },

  awardEventUsers(id, groupId, params) {
    return apiService.post(`/places/event/${id}/users/groups/${groupId || ''}`, params);
  },

  awardEventTeams(id, groupId, params) {
    return apiService.post(`/places/event/${id}/teams/groups/${groupId || ''}`, params);
  },

  cancelStageRewardUsers(id, groupId, params) {
    return apiService.delete(`/places/event-stage/${id}/users/groups/${groupId || ''}`, { data: params });
  },

  cancelStageRewardTeams(id, groupId, params) {
    return apiService.delete(`/places/event-stage/${id}/teams/groups/${groupId || ''}`, { data: params });
  },

  cancelEventRewardTeams(id, groupId, params) {
    return apiService.delete(`/places/event/${id}/teams/groups/${groupId || ''}`, { data: params });
  },

  cancelEventRewardUsers(id, groupId, params) {
    return apiService.delete(`/places/event/${id}/users/groups/${groupId || ''}`, { data: params });
  },
  getMemberEventStage(id, params) {
    return apiService.get(`event-stages/${id}/members`, params);
  },
  getMemberEvent(id, params) {
    return apiService.get(`/events/${id}/members`, params);
  },
  getPublicMemberEvent(id, params) {
    return apiService.get(`/public/events/${id}/members`, params);
  },
  getMemberEventStageTeams(id, params) {
    return apiService.get(`/event-stages/${id}/teams?sort=id`, params);
  },
  getMemberEventTeams(id, params) {
    return apiService.get(`/events/${id}/teams`, params);
  },
  getPublicMemberEventTeams(id, params) {
    return apiService.get(`/public/events/${id}/teams`, params);
  },
  getAchievemets(params) {
    return apiService.get(`/achievements/`, params);
  },
  createAchievemet(params) {
    return apiService.post(`/achievements/`, params);
  },
  deleteAchievement(id, params) {
    return apiService.delete(`/achievements/${id}`, params);
  },
  updateAchievement(id, params) {
    return apiService.put(`/achievements/${id}`, params);
  },
  achievementStageUsers(achievent_id, event_stage_id, params) {
    return apiService.post(`/achievements/${achievent_id}/event-stage/${event_stage_id}/attach-user`, params);
  },
  achievementStageTeams(achievent_id, event_stage_id, params) {
    return apiService.post(`/achievements/${achievent_id}/event-stage/${event_stage_id}/attach-team`, params);
  },
  achievementEventUsers(achievent_id, event_id, params) {
    return apiService.post(`/achievements/${achievent_id}/event/${event_id}/attach-user`, params);
  },
  achievementEventTeams(achievent_id, event_id, params) {
    return apiService.post(`/achievements/${achievent_id}/event/${event_id}/attach-team`, params);
  },
  cancelAchievementStageUsers(achievent_id, event_stage_id, params) {
    return apiService.delete(`/achievements/${achievent_id}/event-stage/${event_stage_id}/attach-user`, { data: params });
  },
  cancelAchievementStageTeams(achievent_id, event_stage_id, params) {
    return apiService.delete(`/achievements/${achievent_id}/event-stage/${event_stage_id}/attach-team`, { data: params });
  },
  cancelAchievementEventUsers(achievent_id, event_id, params) {
    return apiService.delete(`/achievements/${achievent_id}/event/${event_id}/attach-user`, { data: params });
  },
  cancelAchievementEventTeams(achievent_id, event_id, params) {
    return apiService.delete(`/achievements/${achievent_id}/event/${event_id}/attach-team`, { data: params });
  },
  getPlacesStageUsers(id, params) {
    return apiService.get(`/public/places/event-stage/${id}/users`, params);
  },
  getPlacesStageTeams(id, params) {
    return apiService.get(`/public/places/event-stage/${id}/teams`, params);
  },
  getPlacesEventUsers(id, params) {
    return apiService.get(`/public/places/event/${id}/users`, params);
  },
  getPlacesEventTeams(id, params) {
    return apiService.get(`/public/places/event/${id}/teams`, params);
  },
  getUsersTeams(id, params) {
    return apiService.get(`/user-event-info/${id}`, params);
  },
  getOlympicMembersEventStage(id, params) {
    return apiService.get(`/event-stages/${id}/olympic-members`, params);
  },
};
